import React, {Component} from 'react';
import './CountDownTimer.scss';

class CountDownTimer extends Component {
  constructor(props) {
      super(props);
      
      this.state = { time: {}, seconds: 420 };
      this.timer = 0;
      this.startTimer = this.startTimer.bind(this);
      this.countDown = this.countDown.bind(this);
      this.getNumberLength = this.getNumberLength.bind(this);
  }
  
  secondsToTime(secs){
    let hours = Math.floor(secs / (60 * 60));
    let divisor_for_minutes = secs % (60 * 60);
    let minutes = this.getNumberLength(Math.floor(divisor_for_minutes / 60)) == 2 ? Math.floor(divisor_for_minutes / 60) : '0' + Math.floor(divisor_for_minutes / 60);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = this.getNumberLength(Math.ceil(divisor_for_seconds)) == 2 ? Math.ceil(divisor_for_seconds) : '0' +Math.ceil(divisor_for_seconds);
    let obj = {
      "h": hours,
      "m": minutes,
      "s": seconds
    };
    return obj;
  }

  getNumberLength(number) {
    return number.toString().length;
  }

  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }
  
  startTimer() {
    if (this.timer == 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }
  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
    
    // Check if we're at zero.
    if (seconds == 0) { 
      clearInterval(this.timer);
      if (this.props.delegateAction)
        this.props.delegateAction();
    }
  }
  render() {
    this.startTimer();
    return(
      <div className='Countdown-Timer'>
        <div className='Countdown-Timer-Title'>{this.state.time.m}:{this.state.time.s}</div>
      </div>
    );
  }
}

export default CountDownTimer;